const rankings = [
  { rank: 1, title: '星界轮回', type: '韩漫 · 奇幻', heat: '9.8', change: 'up', desc: '异世界轮回题材巅峰之作，华丽画风搭配下拉式阅读体验绝佳' },
  { rank: 2, title: '暗影猎手', type: '日漫 · 热血', heat: '9.7', change: 'up', desc: '王道热血战斗漫画，剧情紧凑，下拉式全集已更新至156话' },
  { rank: 3, title: '甜蜜陷阱', type: '韩漫 · 恋爱', heat: '9.5', change: 'new', desc: '新作即爆款的都市恋爱韩漫，全彩精致画风俘获大批读者' },
  { rank: 4, title: '时空旅人', type: '日漫 · 科幻', heat: '9.3', change: 'same', desc: '科幻烧脑神作第三季回归，下拉式阅读更易理解复杂时间线' },
  { rank: 5, title: '异界事务所', type: '韩漫 · 奇幻', heat: '9.1', change: 'up', desc: '突破200话里程碑的人气韩漫，下拉式完整追更无障碍' },
  { rank: 6, title: '极道学院', type: '日漫 · 校园', heat: '8.9', change: 'down', desc: '校园热血题材常青树，下拉式全集资源丰富，新读者入坑首选' },
  { rank: 7, title: '月光奏鸣曲', type: '韩漫 · 悬疑', heat: '8.7', change: 'up', desc: '悬疑推理口碑佳作，下拉式阅读让线索追踪更加连贯流畅' },
];

const changeIcons: Record<string, { icon: string; color: string }> = {
  up: { icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  down: { icon: 'ri-arrow-down-line', color: 'text-accent-500' },
  same: { icon: 'ri-subtract-line', color: 'text-foreground-400' },
  new: { icon: 'ri-sparkling-line', color: 'text-secondary-500' },
};

const rankMedals: Record<number, string> = {
  1: 'bg-secondary-500 text-background-50',
  2: 'bg-foreground-300 text-background-50',
  3: 'bg-primary-300 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热门排行</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            本周最受欢迎的下拉式漫画排行榜，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
            {rankings.map((item, idx) => (
              <div
                key={idx}
                className={`flex items-center gap-4 p-4 md:p-5 transition-colors duration-200 hover:bg-background-100 cursor-pointer ${idx < rankings.length - 1 ? 'border-b border-background-200/50' : ''}`}
              >
                <div className={`w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${rankMedals[item.rank] || 'bg-background-100 text-foreground-500'}`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900">{item.title}</h3>
                    <span className="text-xs text-foreground-400">{item.type}</span>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed hidden sm:block">{item.desc}</p>
                </div>

                <div className="flex items-center gap-3 flex-shrink-0">
                  <div className="text-right">
                    <div className="text-sm md:text-base font-bold text-foreground-900">{item.heat}</div>
                    <div className="text-xs text-foreground-400">热度</div>
                  </div>
                  <div className={`w-6 h-6 flex items-center justify-center`}>
                    <i className={`${changeIcons[item.change].icon} ${changeIcons[item.change].color} text-sm`}></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}